var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReservationChannelList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1695175162218,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7879,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.073669 914.533082a379.199546 379.199546 0 1 0 0-758.399092 379.199546 379.199546 0 0 0 0 758.399092z m0 70.184225a449.383771 449.383771 0 1 1 0-898.767542 449.383771 449.383771 0 0 1 0 898.767542z m511.314792-757.503396a35.124102 35.124102 0 0 1-60.139628 36.33969 529.228724 529.228724 0 0 0-208.761282-195.901638 35.124102 35.124102 0 1 1 32.309055-62.250913 599.476927 599.476927 0 0 1 236.591855 221.87684z m-1013.096814 0A599.476927 599.476927 0 0 1 241.883502 5.40105a35.124102 35.124102 0 1 1 32.309055 62.314891A529.228724 529.228724 0 0 0 65.431275 263.553601a35.124102 35.124102 0 0 1-60.139628-36.275711z m536.906124 301.082009h217.654269a35.124102 35.124102 0 1 1 0 70.248203H507.073669a35.124102 35.124102 0 0 1-35.124102-35.18808V310.64165a35.124102 35.124102 0 1 1 70.248204 0v217.65427z m-340.748572 472.160056a35.124102 35.124102 0 0 1-62.890696-31.157446l30.773576-62.058977a35.124102 35.124102 0 0 1 62.954674 31.157445l-30.837554 62.058978z m613.872051 0l-30.709597-62.058978a35.124102 35.124102 0 0 1 62.890696-31.221424l30.709597 62.058978a35.124102 35.124102 0 0 1-62.890696 31.221424z",
    fill: "#ffffff",
    "p-id": 7880
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationChannelList);
export default __webpack_public_path__ + "static/media/reservationChannelList.689445fd.svg";
export { ForwardRef as ReactComponent };